import React, {useState} from 'react';
import EmployeUpdateView from './EmployeUpdateView';
import {addEmploye, updateEmploye} from '../../../../services/MadricService';

/**
 *  L'accueil
 * @param {props} props
 * @return {JSX}
 */
function EmployeUpdate(props) {
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    name: props.isUpdate ? props.selectedEmploye.name : '',
    email: props.isUpdate ? props.selectedEmploye.email : '',
    default_hours: props.isUpdate ? props.selectedEmploye.default_hours : '',
    default_minutes: props.isUpdate ? props.selectedEmploye.default_minutes : '',
    password: '',
    confirmPassword: '',
    is_admin: props.isUpdate ? props.selectedEmploye.is_admin : false,
  });


  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckboxChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.checked,
    });
  };

  /**
   * Permet d'envoyer le formulaire
   */
  async function handleSubmit() {
    const errorsForm = {};
    setErrors(errorsForm);

    if (form.name === '') {
      errorsForm.name = 'Le nom de est requis';
    };

    if (form.email === '') {
      errorsForm.emailRequis = 'Le email est requis';
    };

    if (form.password === '' && !props.isUpdate) {
      errorsForm.password = 'Le mot de passe est requis';
    };

    if (form.confirmPassword === '' && !props.isUpdate ) {
      errorsForm.confirmPassword = 'La confirmation de mot de passe est requise';
    };

    if (form.password !== form.confirmPassword) {
      errorsForm.samePassword = 'Les mots de passes ne sont pas identiques';
    };

    if (form.default_hours === '') {
      errorsForm.default_hours = 'Heures de la semaine (régulier) est requis';
    }

    if (form.default_minutes === '') {
      errorsForm.default_minutes = 'Minutes de la semaine (régulier) est requis';
    }

    if (Object.keys(errorsForm).length > 0) {
      setErrors(errorsForm);
    } else {
      props.setIsLoading(true);
      setErrors({});
      const res = props.isUpdate ? await updateEmploye(props.selectedEmploye.id, form) : await addEmploye(form);

      props.setIsLoading(false);

      if (res === 'email already used') {
        errorsForm.emailUsed = 'Ce email est déjà utilisé';
        setErrors(errorsForm);
      } else {
        props.setEmployes(res.data);

        props.closeModal();
        setErrors({});
      }
    }
  }


  return (
    <div>
      <EmployeUpdateView
        closeModal={props.closeModal}
        isUpdate={props.isUpdate}
        handleChange={handleChange}
        form={form}
        errors={errors}
        handleSubmit={handleSubmit}
        handleCheckboxChange={handleCheckboxChange}
      />
    </div>
  );
}

export default EmployeUpdate;
